const priority = {
  'news-priority-form-date-label': 'Дата',
  'news-priority-filter-title': 'Выберите новости по дате',
  'news-priority-title': 'Установите правильный порядок новостей',
  'news-priority-empty': 'На выбранную дату отсутствуют новости.',
};

export default priority;
